/**
 * PC_FB_01 importing the api functions and react functions
 */
import { useState, useEffect } from "react";
import React from "react";
import { getFlagCountAndName, postFeedback } from "../service/DirectorAPI";
import { OnlyNumberSpecialChar, NotificationTrigger } from '../../src/utils/RegHandling';
import $ from 'jquery';
import { connect } from 'react-redux'
import { AES } from "crypto-js";
import { encryptStorage } from '../constant'
import Loader from "../StaticComponent/Loader";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

/**
 * 
 * PC_FB_01.1 this function will return the html
 */
function AddFeedback(props) {

    /**
     * PC_FB_02 creating objects state variables
     */
    let IndivFlagCounts = {
        green_flag: "",
        red_flag: "",
        yellow_flag: "",
        emp_name: "",
        domain: "",
        profile_img_url: ""
    };
    let FeedbackData = {
        Flags: "",
        Comments: "",
        CommentsBasedOn: "0",
    };
    let validationFields = {
        Flags: "",
        Comments: "",
        CommentsBasedOn: ""
    }
    let checkBoxObject = {
        Attitude: false,
        Communication: false,
        Business: false,
        Technology: false,
    }
    let RadioCheck = {
        G: false,
        Y: false,
        R: false
    }
    const [message, setmessage] = useState(validationFields);
    let [checkboxCheck, setCheckboxCheck] = useState(checkBoxObject);
    let [radioCheck, setRadioCheck] = useState(RadioCheck);
    const [isChecked, setIsChecked] = useState([]);
    const [feedbackdata, setFeedbackdata] = useState(FeedbackData);
    const [indivFlagCountsData, setIndivFlagCountsData] = useState(IndivFlagCounts);
    let [emp_name, setEmpName] = useState();
    let [emp_domain, setEmpDomain] = useState();
    let login_emp_id = encryptStorage.getItem("employeeId")
    let role = encryptStorage.getItem("role");
    let CurrentEvaluationId = encryptStorage.getItem("CurrentEvaluationId");
    let [hideForm, setHideForm] = useState(true);
    const [isLoading, setIsLoading] = useState(true);


    /**
     * PC_FB_02.1 this method invock the loadFlagCountPage() api call
     */
    useEffect(() => {
        setEmpName(props.empName);
        setEmpDomain(props.empDomain);
        loadFlagCountPage();
        if (props.hideFeedbackForm == false) {
            // let element = document.getElementById("removeScroll");
            // element.classList.add("removeScroll");

            $("body").addClass("removeScroll");
            setHideForm(props.hideFeedbackForm);
        }
    }, [props]);

    /**
     * PC_FB_02.2 this function retrive the flag count from the db
     */
    const loadFlagCountPage = async () => {
        try {
            let empdata = {
                evaluation_id: CurrentEvaluationId,
                emp_id: props.empId,
                login_emp_id: login_emp_id
            };
            let data = await getFlagCountAndName(empdata);
            if (data.data != undefined && data.data != null && data.data.ResponseData.length != 0) {
                let IndivFlagCounts = {
                    green_flag: data.data.ResponseData[0].green_flag,
                    red_flag: data.data.ResponseData[0].red_flag,
                    yellow_flag: data.data.ResponseData[0].yellow_flag,
                    emp_name: data.data.ResponseData[0].emp_name,
                    domain: data.data.ResponseData[0].domain,
                    profile_img_url: data.data.ResponseData[0].profile_img_url
                };
                setIndivFlagCountsData(IndivFlagCounts);
            }
        } catch (e) {

        }
    };

    /**
     * PC_FB_03 this function will set state the value into the variables
     */

    //commented the onchange for text area
    // const OnChangeName = (e) => {
    //     setFeedbackdata({ ...feedbackdata, [e.target.name]: e.target.value });
    // };

    /**
     * PC_FB_03.1 this function will set state the value into the variables
     */

    const handleRadioChecked = (e) => {

        setFeedbackdata({ ...feedbackdata, [e.target.name]: e.target.id })
        if (e.target.id == "G" && e.target.checked == true) {
            let RadioCheck = {
                G: true,
                Y: false,
                R: false
            }
            radioCheck = RadioCheck
            setRadioCheck(radioCheck);
        }
        if (e.target.id == "Y" && e.target.checked == true) {
            let RadioCheck = {
                G: false,
                Y: true,
                R: false
            }
            radioCheck = RadioCheck
            setRadioCheck(radioCheck);
        }
        if (e.target.id == "R" && e.target.checked == true) {
            let RadioCheck = {
                G: false,
                Y: false,
                R: true
            }
            radioCheck = RadioCheck
            setRadioCheck(radioCheck);
        }
    };

    /**
     * PC_FB_03.2 this function will set state the value into the variables
     */

    const handleCheck = (e) => {
        setCheckboxCheck({ ...checkboxCheck, [e.target.id]: e.target.checked })
        let checkboxList = [...isChecked];
        if (e.target.checked) {
            checkboxList = [...isChecked, e.target.id];
        } else {
            checkboxList.splice(isChecked.indexOf(e.target.id), 1);
        }
        setIsChecked(checkboxList);
    };

    /**
     * PC_FB_03.3 this function will clear the all fields
     */
    const cancelClick = () => {
        let valiclearoption = {
            Flags: 0,
            Comments: "",
            CommentsBasedOn: "",
        };
        setFeedbackdata(valiclearoption);
        let validationFields = {
            Flags: "",
            Comments: "",
            CommentsBasedOn: ""
        }
        setmessage(validationFields);
        let checkBoxObj = {
            Attitude: false,
            Communication: false,
            Business: false,
            Technology: false,
        }
        checkboxCheck = checkBoxObj;
        setCheckboxCheck(checkboxCheck);
        let ClearRadioCheck = {
            G: false,
            Y: false,
            R: false
        }
        radioCheck = ClearRadioCheck
        setRadioCheck(radioCheck);
        setIsChecked('');
        props.setHideFeedbackForm(true);
        setHideForm(true);

        // let element = document.getElementById("removeScroll");
        // element.classList.remove("removeScroll");

        $("body").removeClass("removeScroll");
    }

    /**
     * PC_FB_04 validate the fiels values
     */
    const validation = () => {
        if (feedbackdata.Comments == "") {
            message.Comments = "Drop your comments is required"
            setmessage({ ...message });
        } else {
            message.Comments = ""
            setmessage({ ...message });

            let checkregex = OnlyNumberSpecialChar(feedbackdata.Comments)
            if (checkregex) {

                message.Comments = "Enter a valid comments"
                setmessage({ ...message });
            } else {
                message.Comments = ""
                setmessage({ ...message });
            }
        }
        if (feedbackdata.Flags == "") {
            message.Flags = "Feedback is required"
            setmessage({ ...message });
        } else {
            message.Flags = ""
            setmessage({ ...message });
        }
    }

    /**
     * PC_FB_10 this function post the feedback into the DataBase
     */
    const submitClick = async () => {
        validation();
        try {
            let comments = "";
            for (let i = 0; i < isChecked.length; i++) {
                comments = comments + isChecked[i] + ','
                if (i == (isChecked.length - 1)) {
                    comments = comments.slice(0, -1);
                }
            }
            if (comments == "") {
                message.CommentsBasedOn = "Comments Based on is required"
                setmessage({ ...message });
            } else {
                message.CommentsBasedOn = ""
                setmessage({ ...message });
            }
            let feed_comments ;
            if (feedbackdata.Flags != "" && feedbackdata.Comments != "" && comments != "" && message.Comments == "") {
                setIsLoading(false);
                let encrypted = AES.encrypt(feedbackdata.Comments, "as-south");
                feed_comments = encrypted.toString(); 
                let insertdata = {
                    emp_id: props.empId,
                    login_emp_id: login_emp_id,
                    feedback_by_role: role,
                    evaluation_id: CurrentEvaluationId,
                    flags: feedbackdata.Flags,
                    emp_response: "Pending",
                    comments: feed_comments,
                    comments_based_on: comments,
                };
                let emp = [props.empId];
                let responsedata = await postFeedback(insertdata);
                if (responsedata.data.status == 200) {

                    let feedbackId = responsedata.data.ResponseData[0]
                    // PC_FB_10.1 notification is send to the team member.
                    let value = props.empId;

                    await NotificationTrigger({ title: "Feedback", message: 'Feedback raised against you', route: `/Feedback?EmpId=${value}&FeedbackId=${feedbackId}&EvaluationId=${CurrentEvaluationId}&IsProfile=true&IsTeamMember=true`, state: {}, to_employee: emp, by: login_emp_id }, emp, props.websocket)

                    cancelClick();
                    if (props.ReloadGridPage) {
                        props.ReloadGridPage();
                    }
                    if (props.setHideToast) {
                        props.setHideToast(false);
                    }
                    setHideForm(true);
                    setIsLoading(true);
                }
            }
        } catch (e) {

        }
    }


    return (

        <div
            className="modal fade show"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)' }}
            hidden={hideForm}
        >
            <Loader isLoading={isLoading} />
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <h5 className="modal-title profile-popup-header" id="AddFeedbackDetailsPopupLabel">Add Feedback</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => cancelClick()} />
                    </div>
                    <div className="modal-body addfeedback-pop-scrl">
                        <div className="row mb-4">
                            <div className="col-md-12 profile-spacing mb-4">
                                <div className="profile-left d-flex regular-text">
                                    <div className="d-flex">
                                        <img src="/Images/logo-person-user-person-icon.jpg" alt="User Profile Image" className="profile-image-feedback" />
                                    </div>
                                    <div className="d-grid ms-3">
                                        <span className="font-14 semibold-text team-member-name">{emp_name}</span>
                                        <span className="font-14 pb-0 pt-1 regular-text my-0">{emp_domain}</span>
                                    </div>
                                </div>
                                <div className="d-flex" >
                                    <div className=" d-flex align-items-center me-5">
                                        <div className="profile-feedback-panel profile-feedback-panel-popup profile-feedback-green">
                                        </div>
                                        <div className="text-center profile-flag-count mx-2">{indivFlagCountsData.green_flag ? indivFlagCountsData.green_flag : 0}</div>
                                    </div>
                                    <div className=" d-flex align-items-center me-5">
                                        <div className="profile-feedback-panel profile-feedback-panel-popup profile-feedback-yellow">
                                        </div>
                                        <div className="text-center profile-flag-count mx-2">{indivFlagCountsData.yellow_flag ? indivFlagCountsData.yellow_flag : 0}</div>
                                    </div>
                                    <div className=" d-flex align-items-center">
                                        <div className="profile-feedback-panel profile-feedback-panel-popup profile-feedback-red">
                                        </div>
                                        <div className="text-center profile-flag-count mx-2">{indivFlagCountsData.red_flag ? indivFlagCountsData.red_flag : 0}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mb-4">
                                <label className="form-label hive-form-label w-100">Select Feedback<span className="hive-form-mandatory">*</span></label>
                                <div className="form-check form-check-inline mt-2">
                                    <input className="form-check-input hive-form-check-input" type="radio" name="Flags" id="G" checked={radioCheck.G}
                                        onClick={(e) => handleRadioChecked(e)} />
                                    <label className="form-check-label hive-form-check-label" htmlFor="FeedbackGreen"><img src="/Images/profile-feedback-green.svg" className="profile-feedback-icon-size" alt="Green Feedback" /></label>
                                </div>
                                <div className="form-check form-check-inline mt-2">
                                    <input className="form-check-input hive-form-check-input" type="radio" name="Flags" id="Y" checked={radioCheck.Y}
                                        onClick={(e) => handleRadioChecked(e)} />
                                    <label className="form-check-label hive-form-check-label" htmlFor="FeedbackYellow"><img src="/Images/profile-feedback-yellow.svg" className="profile-feedback-icon-size" alt="Yellow Feedback" /></label>
                                </div>
                                <div className="form-check form-check-inline mt-2">
                                    <input className="form-check-input hive-form-check-input" type="radio" name="Flags" id="R" checked={radioCheck.R}
                                        onClick={(e) => handleRadioChecked(e)} />
                                    <label className="form-check-label hive-form-check-label" htmlFor="FeedbackRed"><img src="/Images/profile-feedback-red.svg" className="profile-feedback-icon-size" alt="Red Feedback" /></label>
                                </div>
                                {message.Flags ? <label className="hive-form-label w-100 hive-form-mandatory hive-form-mandatory">{message.Flags}</label> : null}
                            </div>
                            <div className="col-md-12 mb-4">
                                <label htmlFor="previous-emp-designation" className="form-label hive-form-label w-100">Comments Based on<span className="hive-form-mandatory">*</span></label>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input hive-form-check-input" type="checkbox" id="Attitude"
                                        // Checked={feedbackdata.CommentsBasedOn}
                                        checked={checkboxCheck.Attitude}
                                        onClick={(e) => handleCheck(e)}
                                        maxLength={255}
                                    />
                                    <label className="form-check-label hive-form-check-label" htmlFor="Attitude">Attitude</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input hive-form-check-input" type="checkbox" id="Communication"
                                        // Checked={feedbackdata.CommentsBasedOn}
                                        checked={checkboxCheck.Communication}
                                        onClick={(e) => handleCheck(e)}
                                        maxLength={255}
                                    />
                                    <label className="form-check-label hive-form-check-label" htmlFor="Communication">Communication</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input hive-form-check-input" type="checkbox" id="Business" Checked={true}
                                        checked={checkboxCheck.Business}
                                        onClick={(e) => handleCheck(e)}
                                        maxLength={255}
                                    />
                                    <label className="form-check-label hive-form-check-label" htmlFor="Business">Business</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input hive-form-check-input" type="checkbox" id="Technology"
                                        // Checked={feedbackdata.CommentsBasedOn}
                                        checked={checkboxCheck.Technology}
                                        onClick={(e) => handleCheck(e)}
                                        maxLength={255}
                                    />
                                    <label className="form-check-label hive-form-check-label" htmlFor="Technology">Technology</label>
                                </div>
                                {message.CommentsBasedOn ? <label className=" hive-form-label w-100 hive-form-mandatory">{message.CommentsBasedOn}</label> : null}
                            </div>
                            <div className="col-md-12 mb-2">
                                <label htmlFor="Drop-your-comments" className="form-label hive-form-label">Drop your comments<span className="hive-form-mandatory">*</span></label>

                                <ReactQuill

                                    theme="snow"

                                    id="description"

                                    className="job-posting-commentbox"

                                    value={feedbackdata.Comments}

                                    onChange={(e) => {
                                        FeedbackData.Comments = e;



                                                setFeedbackdata({...feedbackdata,Comments:FeedbackData.Comments})

                                    }}

                                    style={{ minHeight: '100px' }}

                                />
                                {/* <textarea className="form-control hive-form-control" id="Drop-your-comments"
                                    placeholder="Enter here" name="Comments" value={feedbackdata.Comments} onChange={(e) => { OnChangeName(e) }} /> */}
                            </div>
                            <div>
                                {message.Comments ? <label className="hive-form-mandatory">{message.Comments}</label> : null}
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer border-0">
                        <button type="button" className="btn hive-btn-secondary" data-bs-dismiss="modal" onClick={() => cancelClick()}>Cancel</button>
                        <button id="submit" type="button" className="btn hive-btn-primary" onClick={() => { submitClick() }}>Add</button>
                    </div>
                </div>
            </div>
        </div>
    );
}


function mapStateToProps(state) {

    return {
        websocket: state.webSocketAPI
    }
}

export default connect(mapStateToProps)(AddFeedback)